/**
 * static/js/utils/dismissible.js
 *
 * Lets a nudge or banner remember that the user closed it. Mark the container
 * with data-dismiss-key and put a close control inside it carrying
 * data-dismiss-trigger. On load, any container whose key is stored is removed
 * before paint; clicking the trigger stores the key and removes the container.
 *
 * State lives in localStorage (per-device, no server round-trip), keyed under a
 * jn_dismiss_ prefix.
 *
 * Usage:
 *   <div data-dismiss-key="dash_team">
 *     <button data-dismiss-trigger aria-label="Dismiss">&times;</button>
 *     ...
 *   </div>
 */
(function (window, document) {
  'use strict';

  var PREFIX = 'jn_dismiss_';

  function stored(key) {
    try {
      return window.localStorage.getItem(PREFIX + key) === '1';
    } catch (e) {
      return false;
    }
  }

  function remember(key) {
    try {
      window.localStorage.setItem(PREFIX + key, '1');
    } catch (e) {
      // Private mode / storage disabled: dismiss for this view only.
    }
  }

  function wire(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-dismiss-key]').forEach(function (el) {
      if (el.__jn_dismiss_wired) return;
      el.__jn_dismiss_wired = true;
      var key = el.getAttribute('data-dismiss-key');
      if (stored(key)) {
        el.remove();
        return;
      }
      var trigger = el.querySelector('[data-dismiss-trigger]');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          remember(key);
          el.remove();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); });
  } else {
    wire();
  }

  window.JN = window.JN || {};
  window.JN.dismissible = { wire: wire };
})(window, document);
